module.exports = __webpack_public_path__ + "img/list-pause.2b4563fb.png";